import React from "react";

import { Link } from "react-router-dom";

import { Container, CardContainer, Card } from "../../styles/home/explore";

const Explore = () => {
  return (
    <>
      <Container>
        <h1>Explore top providers</h1>
        <CardContainer>
          <Card>
            <Link to="/search/Surulere">
              <h3>Surulere</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Yaba">
              <h3>Yaba</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Oshodi">
              <h3>Oshodi</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Lekki">
              <h3>Lekki</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Ikeja">
              <h3>Ikeja</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Ogba">
              <h3>Ogba</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Ikorodu">
              <h3>Ikorodu</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
          <Card>
            <Link to="/search/Ketu">
              <h3>Ketu</h3>
              <br /> <p>Providers</p>
            </Link>
          </Card>
        </CardContainer>
      </Container>
    </>
  );
};

export default Explore;
